<template>
  <div>
    <draggable
      v-model="mediaArraySnapshot"
      v-bind="dragOptions"
      handle=".handle"
      @start="drag = true"
      @end="drag = false"
    >
      <transition-group tag="div" class="uploaded-images-containter">
        <div
          v-for="(media, index) in mediaArraySnapshot"
          :key="media.uniqueId"
        >
          <UploadedImage
            :media="media"
            :index="index"
            :mediaArrLength="mediaArraySnapshot.length"
            :editPermission="editPermission"
            :deletePermission="deletePermission"
            @delete="deleteImage(index)"
          />
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import UploadedImage from '@/views/apps/referral-program/avatars/form/UploadedImage.vue'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    editPermission: {
      type: Boolean,
      default: false,
    },
    deletePermission: {
      type: Boolean,
      default: false,
    },
    media: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    draggable,
    UploadedImage,
  },
  data: () => ({
    mediaArraySnapshot: [],
    drag: false,
  }),
  watch: {
    drag: {
      handler(val) {
        if (!val) {
          this.$emit('update', this.mediaArraySnapshot)
        }
      },
      deep: true,
    },
    media: {
      handler(val) {
        this.mediaArraySnapshot = cloneDeep(val)
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },
  methods: {
    deleteImage(index) {
      this.mediaArraySnapshot.splice(index, 1)
      this.$emit('delete', index)
    },
  },
}
</script>

<style lang="scss">
.uploaded-images-containter {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
</style>
